import { useSiteConfig } from '../../scripts/selectors/global';

export const DisableAdsOnPage: React.FC<any> = () => {
  const siteConfig = useSiteConfig();
  if (siteConfig.displayAdsProvider === 'mediavine') {
    return <div id="mediavine-settings" data-blocklist-all="1"></div>;
  } else {
    return null;
  }
};
